import { render } from "./index.vue?vue&type=template&id=731406cf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=731406cf&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=731406cf&lang=scss"

import exportComponent from "/home/workspace/cf-dkf-web-micro-base-interior-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731406cf"]])

export default __exports__